<div class="container">
    <div class="text-center m-5">
        <h1>CrossOver Analisi M15</h1>
    </div>

    <div class="row">
        <app-lista-pulsanti-mercati [soloForex]="true" (mercatoSelezionato)="selectMarket($event)"></app-lista-pulsanti-mercati>
    </div>
    <div class="row mt-5">
        <div class="col-6"></div>
        <div class="col-6">
            <div class="d-flex justify-content-center">
                <h3>Trading System</h3>
            </div>
            <form [formGroup]="formTrading">
                <div class="row">
                    <div class="col-6">Stop Loss</div>
                    <div class="col-6 text-end">
                        <input type="text" class="form-control" formControlName="stopLoss" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">Take Profit</div>
                    <div class="col-6 text-end">
                        <input type="text" class="form-control" formControlName="takeProfit" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-end">
                        <button class="btn btn-primary" (click)="tradingSystem()">Filtra</button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-end">
                       Perc.Pos. {{percpos | number: '1.2-2'}} Punti {{puntiTot | number: '1.4-4'}} in {{idAttuale}} su {{datiTotali}}
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-6">
            <app-trading-system-summary [ts]="ts"></app-trading-system-summary>
        </div>
        <div class="col-6">
            <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
                [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
                style="width: 100%; height: 400px; display: block;"></highcharts-chart>
        </div>
    </div>
</div>